module.exports = __webpack_public_path__ + "ST.png?0cf97a4435356651e61d4cb324d04d14";